import useStudioTracking from '@app/hooks/useStudioTracking.js';
import analytics from '../../utils/segment';

const RequestPermissionsButton = (props) => {
	const { updateTrackingState } = useStudioTracking();

	const requestPermissions = async () => {
		props.onPermissionsRequest(props.enabled ? props.enabled : null, 'Request Permissions Button');
		if (Notification.permission !== 'granted') {
			Notification.requestPermission(function (status) {
				console.log('Notification permission status:', status);
				analytics.notificationPermissionsRequestResult(status, 'RequestPermissionsButton');
			});
		}

		updateTrackingState({ permissions: { notification: Notification.permission === 'granted' } });
	};

	return (
		<button
			type="button"
			className="inline-flex items-center justify-center w-full px-4 py-2 mt-3 mb-6 text-base font-medium leading-6 text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-peacock hover:bg-peacockHover hover:text-white focus:border-peacock-700 focus:shadow-outline-peacock active:bg-indigo-700"
			onClick={requestPermissions}
		>
			Request Camera Permissions
		</button>
	);
};

export default RequestPermissionsButton;
